module.exports = __webpack_public_path__ + "static/media/icon-covid-global-deceased.827027ba.svg";